import './button.css';import '../button.shared.css';import '../../tokens/contracts/border_radius/vars.css';import '../../styles/components/state.css';import '../../styles/components/resets.css';/* empty css                                                   */
/* empty css                                                  */
/* empty css                                */
/* empty css                                     */
/* empty css                             */
import { createRuntimeFn } from "@vanilla-extract/recipes/createRuntimeFn";
//#region src/components/button/button.css.ts
var buttonIconSlot = "_1vstmve1";
var buttonIconSvg = "_1vstmve2";
var buttonRecipe = createRuntimeFn({
	defaultClassName: "_1vstmve3 _1vstmve0 yto5w40 _14zs3h0 _14zs3h1 _16pesku1 _16pesku3",
	variantClassNames: {
		kind: {
			primary: "_1vstmve4",
			secondary: "_1vstmve5",
			text: "_1vstmve6"
		},
		intent: {
			neutral: "_1vstmve7",
			danger: "_1vstmve8"
		},
		disabled: {
			true: "_1vstmve9 _16pesku0",
			false: "_1vstmvea"
		}
	},
	defaultVariants: {
		kind: "primary",
		intent: "neutral",
		disabled: false
	},
	compoundVariants: [
		[{
			kind: "primary",
			intent: "neutral"
		}, "_1vstmveb yto5w41"],
		[{
			kind: "primary",
			intent: "danger"
		}, "_1vstmvec"],
		[{
			kind: "secondary",
			intent: "neutral"
		}, "_1vstmved"],
		[{
			kind: "text",
			intent: "neutral"
		}, "_1vstmvee"],
		[{
			kind: "primary",
			intent: "neutral",
			disabled: true
		}, "_1vstmvef"],
		[{
			kind: "primary",
			intent: "danger",
			disabled: true
		}, "_1vstmveg"],
		[{
			kind: "secondary",
			intent: "neutral",
			disabled: true
		}, "_1vstmveh"],
		[{
			kind: "text",
			intent: "neutral",
			disabled: true
		}, "_1vstmvei"]
	]
});
//#endregion
export { buttonIconSlot, buttonIconSvg, buttonRecipe };
